import {useUpmPlantTimezone} from '@hconnect/upm'
import {StackProps} from '@mui/material'
import {getLocalizedDayMonthTimeFormat} from '@widgets/planning-schedule-chart'
import {Moment} from 'moment-timezone'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../../consts'

interface StockLevelsOverviewSubtitleProps extends StackProps {
  lastUpdated: Moment
}

export const StockLevelsOverviewSubtitle: FC<StockLevelsOverviewSubtitleProps> = React.memo(
  ({lastUpdated}) => {
    const timezoneId = useUpmPlantTimezone()
    const {
      t,
      i18n: {language}
    } = useTranslation(FEATURE_NAMESPACE)

    return (
      <>
        {lastUpdated &&
          t('common.lastUpdate', {
            date: getLocalizedDayMonthTimeFormat(lastUpdated, timezoneId, language)
          })}
      </>
    )
  }
)

StockLevelsOverviewSubtitle.displayName = 'StockLevelsOverviewTitle'
